import React from 'react'

export const PhotoStatusModeratingSvg = ({ size = '24', color = 'white' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <path stroke={color} strokeWidth="2" d="M16 16l5.5 5.5" />
      <path
        stroke={color}
        strokeWidth="1.5"
        d="M18 10.5a7.501 7.501 0 0 1-15 0 7.5 7.5 0 0 1 15 0z"
      />
      <circle cx="10.7" cy="14.1" r="1.1" fill={color} />
      <path
        stroke={color}
        strokeWidth="1.5"
        d="M8.7 8.743c0-2.046 2.32-2.219 3.234-1.626.921.598.713 1.705.39 2.24-.51.841-1.665 1.109-1.665 2.662"
      />
    </g>
  </svg>
)
